// extracted by mini-css-extract-plugin
export default {"finishSetup":"_o5amxy","header":"_1rmbu35","appCard":"_s3n3kd","column":"_1pet1p6","addToSite":"_1vydra7","manageAppsLink":"_nkywt1"};